import { useState, useEffect } from "react";

import { getModalStyle } from '@/utils/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import DropdownTable from '@/components/DropdownTable';

import {
    Check as AcceptIcon,
    Close as CloseIcon
} from '@mui/icons-material';

// when editing table inline, some fields cannot be edited directly, so modal needed
export default function EditionModal({t, open, setOpen, table, columns, 
    column, params, options, handleEdition, fullScreen}){
    
    const { sxDialog } = getModalStyle();

    const handleClose = () => setOpen(false);

    const [ type, setType ] = useState(null);
    const [ value, setValue ] = useState(null);

    const [ dropdownTypes ] = useState(['dropdown','dropdown_multiple','dropdown_search']);

    useEffect(() => {

        if(open){

            var newType = null;
            if(columns && Object?.hasOwn(columns,column) && Object?.hasOwn(columns[column],'type')){
                newType = columns[column]?.type;
            }

            setType(newType);
            setValue(params?.value);
        }
        else{
            setType(null);
            setValue(null);
        }
    },[open]);

    const handleDropdownChange = (dropdownData) => {

        var newValue = null;

        if(type && type === 'dropdown_multiple'){
            newValue = dropdownData;
        }
        else{
            if(type && type === 'dropdown_search'){
                newValue = dropdownData?.id ? dropdownData.id : null;
            }
            else{
                // single
                newValue = dropdownData;
            }
        }

        setValue(newValue);        
    }

    return (
        <Dialog 
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose} 
            open={open}
            fullWidth={true}
            maxWidth='md'
        >               
            <DialogTitle className='modal-title'>
                {t(table+'.fields.'+column)}
            </DialogTitle>
            {/*      
            <IconButton                    
                onClick={handleClose}
                sx={sxCloseIcon}
            >
                <CloseIcon />
            </IconButton>
            */}
            <DialogContent className='modal-content !px-0 !mx-0 !min-h-60'>
                {
                    open &&
                    <div className='px-2 pt-2'>
                        {
                            dropdownTypes?.includes(type) ?                            
                                <DropdownTable
                                    t={t}                                                    
                                    type={type && type === 'dropdown_multiple' ? 'multiple' : type && type === 'dropdown_search' ? 'search' : 'single'}
                                    table={table}
                                    column={column}
                                    node={params?.node}                                                    
                                    value={value}
                                    options={options}
                                    handleDropdown={handleDropdownChange}
                                />
                            :
                                <></>
                        }
                    </div>
                }
            </DialogContent>
            <div className="modal-buttons">
                <div className='me-1'>
                    <AcceptIcon 
                        className='action-button-modal text-green-800' 
                        onClick={(e) => handleEdition(e,column,value)}
                    />
                </div>
                <div className=''>
                    <CloseIcon 
                        className='action-button-modal text-black' 
                        onClick={handleClose}
                    />
                </div>
            </div>
        </Dialog>
  );
}